import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7p5vnswqfb: FaireBrandEntity = {
  token: "b_7p5vnswqfb",
  type: "brand",
  name: "MEGASNAX",
  avatarUrl:
    "https://cdn.faire.com/fastly/e0d63bcd5cdd4a37ff13612936959fb6ae747bec0ab6d3dbb68b5eec000393f5.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c6c9b1ef0016499ea1fdfd815d39bc2dc626d7243ed95bca2f8ca7257404c84b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e0d63bcd5cdd4a37ff13612936959fb6ae747bec0ab6d3dbb68b5eec000393f5.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c6c9b1ef0016499ea1fdfd815d39bc2dc626d7243ed95bca2f8ca7257404c84b.jpeg",
  location: "SHINER, TX, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "Based in Shiner, Texas, MegaSnax is one of Texas biggest distributors of snack items to independent convenience stores. We offer a large variety of candy, beef jerky, nuts and more.\n\nMegaSnax...the fun starts here!",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:18.776Z",
    importedBy: "entity-db-cli",
  },
};
